// extracted by mini-css-extract-plugin
export default {"cta":"lH-z","disabled":"mH-z"};